const ScrollToElement = (elementId) =>
  document.getElementById(elementId).scrollIntoView({
    behavior: "smooth",
  });

export default ScrollToElement;
